/**
 * Format a Date object as YYYY-MM-DD string for API calls.
 * Avoids timezone conversion issues that occur with .toISOString()
 */
export function formatDateForAPI(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
